import React, { Component } from 'react';

import MetaImage from 'img/landing/outlier-helmet.webp';

import Helmet from './Helmet';

const Title = 'Outlier Case Study | Canny';
const Description =
  'Read about how Outlier scored big with product-led growth and community engagement.';

export default class OutlierLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: MetaImage },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/outlier' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: MetaImage },
        ]}
      />
    );
  }
}
